import { render, staticRenderFns } from "./moreOUOEnew.vue?vue&type=template&id=6a271f64&lang=pug&"
import script from "./moreOUOEnew.vue?vue&type=script&lang=js&"
export * from "./moreOUOEnew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports